const state = {
  // leave | task | quitting | finishing
  viewType: 'leave',
  step: 1
}

const getters = {
  viewType: state => state.viewType,
  step: state => state.step
}

const mutations = {
  setViewType (state, val) {
    state.viewType = val;
  },
  setStep (state, val) {
    state.step = val;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/userTask.js